import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../constants/api';
import { notification } from 'antd';

const DataEntryTable = ({
  data,
  reportHeader,
  reportFooter,
  link,
  token,
  executionTime,
  setData,
}) => {
  const [columns, setColumns] = useState([]);
  // Step 1: Define the state to track which rows have been processed
  const [processedRows, setProcessedRows] = useState([]);

  useEffect(() => {
    // Fetch column definitions and data from the API
    const columns = Object.keys(data[0]);

    setColumns(
      columns.map((col) => {
        const parts = col.split('~');
        return {
          columnName: col,
          header: parts[0],
          key: parts[1] || parts[0],
          visible: parts[2] !== 'hide',
          editable: !!parts[1], // Editable only if `column_name` is present
        };
      })
    );
  }, []);
  const [search, setSearch] = useState('');

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  var filteredData;
  try {
    filteredData = data.filter((row) =>
      Object.values(row).some((val) =>
        String(val).toLowerCase().includes(search.toLowerCase())
      )
    );
  } catch (error) {
    notification.error({ message: error.message });
  }

  const handleEdit = (e, rowIndex, columnName) => {
    const updatedData = [...data];
    updatedData[rowIndex][columnName] = e.target.textContent;
    setData(updatedData);
  };

  console.log('columns:', columns);
  const handleSubmit = async (row, rowIndex) => {
    const filteredRow = Object.keys(row).reduce((acc, key) => {
      const parts = key.split('~');

      // Only include keys that have a valid second part (the column name)
      if (parts.length >= 2) {
        acc[parts[1]] = row[key]; // Use the column name part as the key
      }
      return acc;
    }, {});

    const route = filteredRow.api_route;
    delete filteredRow.api_route;
    console.log('Filtered row for submission:', filteredRow, 'route:', route);
    var insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/${route}`;

    const response = await axios.post(insertUrl, filteredRow, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });

    const { success, message } = response.data;
    if (success === 1) {
      setProcessedRows((prev) => [...prev, rowIndex]); // Track the processed row by ID

      notification.success({ message: message });
    } else {
      notification.error({ message: message });
    }
  };

  return (
    <div className=" ">
      <div className="row">
        <div className="col-9"></div>
        <div className="col-3">
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={handleSearch}
            className="form-control mb-3"
            style={{ maxWidth: '300px' }} // Optional: Limit max width for better alignment
          />
        </div>
      </div>
      <table className="table table-bordered">
        <thead className="table-dark">
          <tr>
            {columns
              .filter((col) => col.visible)
              .map((col) => (
                <th key={col.key}>{col.header}</th>
              ))}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredData &&
            filteredData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns
                  .filter((col) => col.visible)
                  .map((col) => (
                    <td
                      key={col.key}
                      contentEditable={col.editable}
                      suppressContentEditableWarning={col.editable}
                      onBlur={
                        col.editable
                          ? (e) => handleEdit(e, rowIndex, col.columnName)
                          : undefined
                      }
                      style={col.editable ? { backgroundColor: '#f9f9f9' } : {}}
                    >
                      {row[col.columnName]}
                    </td>
                  ))}
                <td>
                  <button
                    className="btn btn-sm btn-success"
                    onClick={() => handleSubmit(row, rowIndex)}
                    disabled={processedRows.includes(rowIndex)} // Step 3: Disable if processed
                  >
                    ✅
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataEntryTable;
